<template>
  <v-container fluid class="pa-0">
    <!--TOOLBAR-->
    <v-app-bar flat color="red-darken-3">
      <!--TITLE-->
      <v-app-bar-title class="hidden-sm-and-down">
        {{ $t("clients.label") }}
      </v-app-bar-title>
      <v-divider class="mx-5 hidden-sm-and-down" inset vertical />
      <!--SEARCH FIELD-->
      <v-text-field
        v-model="search"
        :label="$t('clients.search')"
        flat
        variant="solo"
        color="red-darken-1"
        append-inner-icon="mdi-magnify"
        single-line
        hide-details
        class="mx-1"
      />
      <v-spacer class="hidden-sm-and-down" />
      <v-btn
        v-if="selected && selected.items && selected.items.length > 0"
        color="grey-darken-4"
        variant="flat"
        :loading="loadingDelete"
        class="mx-1"
        @click="deleteClients"
      >
        {{ $t("clients.delete") }}
        <v-icon end>mdi-delete</v-icon>
      </v-btn>
      <v-btn
        v-if="
          $store.getters.role == 'LekoAdmin' ||
          $store.getters.role == 'LekoEmployee' ||
          $store.getters.role == 'InstitutionAdmin' ||
          $store.getters.role == 'InstitutionManager' ||
          $store.getters.role == 'SuperAdmin'
        "
        color="grey-darken-4"
        variant="flat"
        @click="newClient"
      >
        {{ $t("clients.button") }}
        <v-icon end>mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>
    <!--ALERT-->
    <v-alert
      :model-value="alert.value"
      type="error"
      variant="tonal"
      border="bottom"
    >
      {{ alert.message }}
    </v-alert>
    <!--EDIT DIALOG-->
    <edit-dialog
      ref="editDialog"
      @saved="getClients"
      @add-vehicle="openVehicleDialog"
    />
    <!--DETAILS DIALOG-->
    <details-dialog ref="detailsDialog" @saved="getClients" />
    <!--DATATABLE-->
    <datatable
      ref="datatable"
      :search="search"
      @edit="openEditDialog"
      @details="openDetailsDialog"
      @selected="setSelectedItems"
    />
    <!--VEHICLE DIALOG-->
    <vehicle-dialog
      ref="vehicleDialog"
      @save="saveVehicle"
      @close="closeVehicleDialog"
    />
    <v-dialog v-model="dialogDelete" width="auto">
      <v-card>
        <v-card-title class="text-h6">
          <v-alert class="mb-0" :value="true" type="error">
            {{ $t("delete_alert") }}
          </v-alert>
        </v-card-title>

        <v-card-actions>
          <v-spacer />
          <v-btn variant="text" @click="dialogDelete = false">
            {{ $t("close") }}
          </v-btn>
          <v-btn color="red" variant="outlined" @click="confirmDelete()">
            {{ $t("delete") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
// import ManageClients from '@/components/Clients/Clients.vue';
import EditDialog from "@/components/Clients/editDialog.vue";
import VehicleDialog from "@/components/Clients/vehicleDialog.vue";
import DetailsDialog from "@/components/Clients/detailsDialog.vue";
import Datatable from "@/components/Clients/datatable.vue";

import deleteRequest from "../api/deleteRequest";

export default {
  components: {
    // 'manage-clients': ManageClients,
    "edit-dialog": EditDialog,
    "details-dialog": DetailsDialog,
    "vehicle-dialog": VehicleDialog,
    datatable: Datatable,
  },
  data: () => ({
    search: "",
    selected: [],
    loadingDelete: false,
    alert: {
      value: false,
      message: "",
    },
    dialogDelete: false,
  }),
  watch: {},
  methods: {
    newClient() {
      const { editDialog } = this.$refs;
      editDialog.open(false, null, this.$store.getters.institutionId);
    },
    getClients() {
      const { datatable } = this.$refs;
      datatable.getClients();
    },
    openEditDialog(data) {
      const { editDialog } = this.$refs;
      editDialog.open(true, data, this.$store.getters.institutionId);
    },
    openDetailsDialog(id) {
      const { detailsDialog } = this.$refs;
      detailsDialog.open(id);
    },
    openVehicleDialog(data) {
      const { vehicleDialog } = this.$refs;
      vehicleDialog.open(data);
    },
    closeVehicleDialog() {
      const { editDialog } = this.$refs;
      editDialog.show();
    },
    saveVehicle(data) {
      const { editDialog } = this.$refs;
      editDialog.addVehicle(data);
    },
    setSelectedItems(data) {
      this.selected = data;
    },
    deleteClients() {
      this.dialogDelete = true;
    },
    confirmDelete() {
      this.loadingDelete = true;
      const ids = this.selected.map((s) => s._id).join(",");
      deleteRequest("/client/", `ids=${ids}`)
        .then(() => {
          this.getClients();
        })
        .catch(() => {})
        .finally(() => {
          this.loadingDelete = false;
          this.dialogDelete = false;
        });
    },
  },
};
</script>
